import React from "react";
import styled from "styled-components";
import { designTokens, getTypography } from "../../styles/designTokens";
import { SummaryData } from "../../apis/dashboard/summary";
import { KoTitle1 } from "../../styles/sharedStyles";
import { FiUpload, FiVideo, FiHeadphones, FiClock } from "react-icons/fi";

const OverviewSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 24px;
`;

const OverviewTitle = styled(KoTitle1)`
  color: ${designTokens.colors.font.primary};
  font-weight: 600;
`;

const OverviewGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 24px;
  width: 100%;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: #ffffff;
  border: 1px solid ${designTokens.colors.line.section};
  border-radius: 12px;
  padding: 24px 28px;
  box-shadow: 0px 10px 24px rgba(92, 110, 255, 0.08),
              0px 2px 6px rgba(0, 0, 0, 0.03);
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0px 14px 28px rgba(92, 110, 255, 0.15),
                0px 3px 8px rgba(0, 0, 0, 0.05);
  }

  @media (max-width: 480px) {
    align-items: center;
    text-align: center;
    padding: 20px;
  }
`;


const IconCircle = styled.div<{ color: string }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${(props) => `${props.color}15`};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;

  svg {
    color: #5C6EFF;
    width: 18px;
    height: 18px;
  }
`;

const Label = styled.div`
  ${getTypography("korean", "body3")};
  color: ${designTokens.colors.font.secondary};
  font-weight: 500;
  margin-bottom: 4px;
`;

const Value = styled.div`
  ${getTypography("korean", "body1")};
  color: ${designTokens.colors.font.primary};
  font-weight: 600;
`;

interface OverviewProps {
  summary?: SummaryData | null;
}

export const Overview: React.FC<OverviewProps> = ({ summary }) => {
  const safeSummary = summary || {
    totalCount: 0,
    totalDuration: 0,
    video: 0,
    audio: 0,
  };

  const cards = [
    {
      label: "업로드",
      value: safeSummary.totalCount,
      icon: <FiUpload />,
      color: "#5C6EFF",
    },
    {
      label: "비디오",
      value: safeSummary.video,
      icon: <FiVideo />,
      color: "#7D8BFF",
    },
    {
      label: "오디오",
      value: safeSummary.audio,
      icon: <FiHeadphones />,
      color: "#A1A9FF",
    },
    {
      label: "파일 길이",
      value: safeSummary.totalDuration,
      icon: <FiClock />,
      color: "#C1C8FF",
    },
  ];

  return (
    <OverviewSection>
      <OverviewTitle>분석 개요</OverviewTitle>
      <OverviewGrid>
        {cards.map((item) => (
          <Card key={item.label}>
            <IconCircle color={item.color}>{item.icon}</IconCircle>
            <Label>{item.label}</Label>
            <Value>{item.value}</Value>
          </Card>
        ))}
      </OverviewGrid>
    </OverviewSection>
  );
};
